import React from "react";
import { Resources } from "../utils/resources";
import { Button } from "./Button";
import { TextButton } from "./TextButton";
import navigateIcon from "../assets/icons/navigate-icon.svg";

interface SignpostingProps {
  category: string;
  onWhyAmISeeingThis: () => void;
}

interface SignpostingData {
  title: string;
  messages: string[];
  helpLink: string;
  organizationName: string;
  phoneNumber: string;
  ctaText?: string;
}

const Signposting: React.FC<SignpostingProps> = ({
  category,
  onWhyAmISeeingThis,
}) => {
  const signpostingData = (Resources as any).signpostingData?.[category] as
    | SignpostingData
    | undefined;

  if (!signpostingData) {
    return (
      <div className="text-center">
        <p>Signposting data not found.</p>
      </div>
    );
  }

  const organizationName = signpostingData.organizationName;

  return (
    <div>
      <div className="flex items-center mb-3">
        <img alt="benefits icon" src={navigateIcon} />
        <h2 className="text-xl ml-2.5">{signpostingData.title} </h2>
      </div>

      <div className="container-white-rounded">
        <TextButton
          text="Why am I seeing this?"
          onClick={onWhyAmISeeingThis}
          className="mb-4"
        />
        {signpostingData.messages.map((message: string, index: number) => (
          <p key={index} className="text-base">
            {message}
          </p>
        ))}
        <div className="flex justify-center mt-4">
          <Button
            text={`Visit ${organizationName}`}
            onClick={() => window.open(signpostingData.helpLink, "_blank")}
          />
        </div>
      </div>
    </div>
  );
};

export default Signposting;
